import { exploreSchemaItemList } from '@/templates/Landing/seoLandings/exploreSchema';
import { ENV } from '@/constants';

export const schemaObject_AiChibiMaker = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-chibi-maker',
			name: 'Chibi Maker: AI Chibi Generator & Avatar Creator | Lift',
			description:
				"Create cute Chibi ai characters from your photos instantly with Lift's AI Chibi avatar maker. No watermark — generate Chibi art, avatars & anime-style characters in seconds",
			url: 'https://liftapp.ai/ai-chibi-maker',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-chibi-maker#product' },
				{ '@id': 'https://liftapp.ai/ai-chibi-maker#howto' },
				{ '@id': 'https://liftapp.ai/ai-chibi-maker#benefits' },
				{ '@id': 'https://liftapp.ai/ai-chibi-maker#faq' },
				{ '@id': 'https://liftapp.ai/ai-chibi-maker#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-chibi-maker#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-chibi-maker#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-chibi-maker#product',
			name: 'AI Chibi Generator',
			description:
				"Create cute Chibi ai characters from your photos instantly with Lift's AI Chibi avatar maker. No watermark — generate Chibi art, avatars & anime-style characters in seconds.",
			url: 'https://liftapp.ai/ai-chibi-maker',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-chibi-maker#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: 'Select a photo from your gallery or snap one directly in the app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI transforms you into Chibi style',
					text: 'Our AI instantly converts your photo into an adorable Chibi character',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Apply the transformation',
					text: 'Let AI reimagine your photo in seconds',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and share',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-chibi-maker#benefits',
			name: 'Who can benefit from AI Chibi Maker?',
			description:
				"Lift's AI Chibi Maker is perfect for anime fans, content creators, gamers, streamers, and social media users who want to create adorable chibi-style characters from their photos.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Anime lovers turning selfies into kawaii chibi portraits',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Gamers and streamers creating mascot avatars or emotes',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators designing cute channel art and stickers',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Cosplayers and fandom groups making matching chibi squads',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Social media users refreshing pfps with playful chibi vibes',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Gift givers surprising friends with adorable custom art',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Chibi Character Maker by Lift',
				description:
					'Example of how Lift AI Chibi Maker transforms photos into adorable chibi-style characters.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-chibi-maker#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Chibi Maker?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Chibi Maker is an online tool that transforms your photos into adorable chibi-style characters — featuring the signature oversized heads, cute proportions, and expressive eyes that define chibi art. Perfect for avatars, social media, stickers, or creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Chibi Maker work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo with deep learning, identifies your facial features and expressions, then reimagines you in authentic chibi art style with exaggerated proportions, big expressive eyes, and kawaii aesthetics. Everything is automatic — no manual drawing or editing skills required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create chibi art from any photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift works best with clear portraits but can transform any photo into chibi style. The AI adapts to your image content and applies chibi proportions, cute features, and anime-inspired details while maintaining your unique characteristics and personality.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, Discord avatars, print, merchandise, or any creative project.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-chibi-maker#why-lift',
			name: "Why Lift's AI Chibi Maker stands out",
			description:
				"Lift's Chibi Maker combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why use Lift AI Chibi Maker',
				description:
					"Comparison of Lift's AI Chibi Maker benefits — high-quality results, intelligent rendering, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-chibi-maker#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-chibi-maker#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Chibi Maker',
					item: 'https://liftapp.ai/ai-chibi-maker',
				},
			],
		},
	],
};
